// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3ed71664","453":"cda344f3","455":"1ce72f50","946":"9cfb3dc8"}[chunkId] + ".chunk.js";
};